<template>
    <div>
        <h2>{{ title }}</h2>
        <section class="vcalender">
            <div class="experience vevent vcard">
                <div class="experience-item" v-bind:key="item.company" v-for="item in json">
                    <a href="http://marioqueiros.com/#resname" class="include"></a><span class="datum"><time class="dtstart" v-bind:datetime="item.from" v-bind:title="item.to">{{item.from}}</time> to <span>{{item.to}}</span></span>
                    <h3><a v-bind:href="item.url" target="_blank" class="org fn">{{ item.company }}</a></h3>
                    <h4 class="title">{{ item.title }}</h4>
                    <div class="description summary">
                        <ul v-for="project in item.projects" v-bind:key="project.title">
                            <li v-if="project.url">                                
                                    <a target="_blank" v-bind:href="project.url">{{project.title}}</a>
                            </li>
                            <li v-else>                                
                                    {{project.title}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "Experience",
  props: {
    title: String,
    json: Array
  }
};
</script>